import { Mutations, Actions, Module, Getters } from 'vuex-smart-module'

export class SettingsState {
  mainFontSize: '20' | '22' | '24' = '20'
  fontSizes = [
    { name: 'Обычный', value: '20' },
    { name: 'Средний', value: '22' },
    { name: 'Большой', value: '24' },
  ]
}

export class SettingsGetters extends Getters<SettingsState> {
  get mediumOrLargeFontSize() {
    return this.state.mainFontSize !== '20'
  }
}

export class SettingsMutations extends Mutations<SettingsState> {
  setFontSize(size: '20' | '22' | '24') {
    this.state.mainFontSize = size
  }
}

export class SettingsActions extends Actions<SettingsState, SettingsGetters, SettingsMutations, SettingsActions> {}

export const settings = new Module<SettingsState, SettingsGetters, SettingsMutations, SettingsActions>({
  state: SettingsState,
  getters: SettingsGetters,
  mutations: SettingsMutations,
  actions: SettingsActions,
})
